export const namespaceKey = '__INNERWELL__';

export const nonceHeaderKey = 'x-nonce';
